"use strict";

var _classCallCheck = require("/vercel/612421a5/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/vercel/612421a5/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

exports.implementation = /*#__PURE__*/function () {
  function NavigatorCookiesImpl() {
    _classCallCheck(this, NavigatorCookiesImpl);
  }

  _createClass(NavigatorCookiesImpl, [{
    key: "cookieEnabled",
    get: function get() {
      return true;
    }
  }]);

  return NavigatorCookiesImpl;
}();